// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2SRAW","consentsList":"PatientConsents_consentsList__3cmL3","consentsListEmpty":"PatientConsents_consentsListEmpty__8OsYm"};